module.exports = __webpack_public_path__ + "static/bsides-fa317b50fb2e579e0b2d7df6b6a08ade.png";